<template>
  <div>
    <div class="app-head">
      <div class="title">{{ $store.state.sys.title }}</div>
      <div class="menu">
        <!-- <div class="menu-item" :class="{ 'active': key == '/orders' }" @click="menuClick('orders')">
          订单列表
        </div>
        <div class="menu-item" :class="{ 'active': key == '/refundorders' }" @click="menuClick('refundorders')">
          售后列表
        </div>
        <div class="menu-item" @click="onSync">
          同步订单
        </div> -->
        <div class="menu-item" :class="{ 'active': key == '/printandship' }" @click="menuClick('printandship')">打印发货
        </div>
        <div class="menu-item" :class="{ 'active': key == '/freeprint' }" @click="menuClick('freeprint')">自由打印</div>
        <div class="menu-item" :class="{ 'active': key == '/actionlog' }" @click="menuClick('actionlog')">操作日志</div>
        <div class="menu-item" :class="{ 'active': key == '/setting' }" @click="menuClick('setting')">系统设置</div>
      </div>
      <div class="action">
        <div></div>
        <div>
          <div class="msg-icon" @click="showMsgBox = true">
            <el-badge is-dot :hidden="!showBadge">
              <i class="el-icon-bell"></i>
            </el-badge>
          </div>
        </div>
        <!-- <div class="logo">
          <el-image :src="mallInfo.logo"></el-image>
        </div> -->
        <div class="user-info">
          <el-popover placement="bottom-end" trigger="click">
            <div class="user-info-item text-hidden">
              店铺名：<span :title="mallInfo.mallName">{{ mallInfo.mallName }}</span>
            </div>
            <div class="user-info-item text-hidden">
              店铺秘钥：<span id="key" :title="mallInfo.secretKey" @mouseover="onSelectText">{{ mallInfo.secretKey }}</span>
            </div>
            <div class="user-info-box">
              <div class="btn" @click="logout">退出账号</div>
            </div>
            <div slot="reference" class="text-hidden">{{ mallInfo.mallName }}</div>
          </el-popover>
        </div>
      </div>
    </div>
    <section class="app-main">
      <transition name="fade-transform" mode="out-in">
        <keep-alive :include="cachedViews" :exclude="exclude">
          <router-view v-if="refresh" :key="key" />
        </keep-alive>
      </transition>
    </section>
    <el-dialog title="消息通知" :visible.sync="showMsgBox" class="dialog-center" width="700px">
      <div class="msg-title">
        <el-link type="info" :underline="false" @click="setMsgAllRead">全部设为已读</el-link>
      </div>
      <div style="height: 1px;background-color: #dedede;margin-bottom: 0px;"></div>
      <div class="msg-box m-scroll">
        <div v-for="(i, k) in msgList" :key="k" class="msg-item" :class="{ 'msg-is-click': i.isRead }"
          v-rightclick="(e) => { showMenu(e, i) }" @click="setMsgRead(i)">
          <div class="overflow" v-html="i.msgContent"></div>
        </div>
      </div>
      <div id="content-menu" class="content-menu" v-show="showContentMenu">
        <div class="item" @click="copyOrderSn">复制订单号</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import windowsVisibility from "@/utils/windowsVisibility";
import { constructor, active } from "@/utils/userActive";
export default {
  name: "AppMain",
  data() {
    return {
      api: require('@/api/ali/order').default,
      messageApi: require('@/api/ali/message').default,
      syncLoading: false,
      refresh: true,
      exclude: null,
      showMall: false,
      showMsgBox: false,
      msgList: [],
      // isSyncOrder: false,
      syncLogisticsInterval: null,
      isSyncLogistics: false,
      showContentMenu: false,
      contentData: null,
      isWinHidden: false, // 标签页是否隐藏
    };
  },
  watch: {
    showMsgBox(val) {
      console.log("showMsgBox", val)
      if (val) window.addEventListener("click", this.closeMenu);
      else window.removeEventListener("click", this.closeMenu);
    }
  },
  computed: {
    cachedViews() {
      return this.$store.state.tags.cachedViews;
    },
    key() {
      return this.$route.path;
    },
    mallInfo() {
      var data = {}
      var user_info = localStorage.getItem("user-info");
      if (user_info) {
        data = { ...data, ...JSON.parse(user_info) };
      }
      console.log("mallInfo", data);
      return data
    },
    showBadge() {
      return this.msgList.filter(x => x.isRead == false).length > 0;
    },
    isSyncOrder() {
      return this.$store.state.sys.isSyncOrder;
    }
  },
  mounted() {
    this.getMessage();
    this.syncLogistics();
    windowsVisibility(this.visibility);
    constructor();
  },
  methods: {
    visibility(hidden) {
      console.log("visibility", hidden);
      this.isWinHidden = hidden;
    },
    refreshView(name) {
      //隐藏组件
      this.refresh = false;
      //增加排除
      this.exclude = name;
      this.$nextTick((_) => {
        //删除排除
        this.exclude = null;
        //显示组件
        this.refresh = true;
      });
    },
    menuClick(url) {
      this.$router.push(url)
    },
    onSelectText(event) {
      // 获取一个Selection对象
      const selection = window.getSelection();
      // 先清空一下以选择的内容
      selection?.removeAllRanges();
      // 创建一个range对象
      const range = document.createRange();
      // 让range对象包含一个node的内容
      range.selectNodeContents(event.target);
      // 向selection中添加一个区域（range）
      selection?.addRange(range);
    },
    async logout() {
      await this.$store.dispatch("logout").then((res) => {
        this.$store.dispatch("clearStorage");
        window.location.reload();
      });
    },
    syncLogistics() {
      this.startSync().then(res => {
        this.syncLogisticsInterval = setInterval(() => {
          if (!this.isWinHidden && active()) {
            if (!this.isSyncLogistics && this.isSyncOrder == false) {
              this.startSync().then(res => {
              }).catch(err => {
                clearInterval(this.syncLogisticsInterval)
              })
              // this.api.syncLogistics().then(res => {
              //   this.isSyncLogistics = true;
              //   var interval = setInterval(() => {
              //     this.api.syncLogisticsStatus().then(res => {
              //       if (res.syncStatus != 1) {
              //         clearInterval(interval);
              //         this.isSyncLogistics = false;
              //         this.getMessage();
              //       }
              //     }).catch(err => {
              //       clearInterval(interval);
              //       this.isSyncLogistics = false;
              //     })
              //   }, 3000);
              // }).catch(err => {
              //   clearInterval(this.syncLogisticsInterval)
              // })
            }
          }
        }, 1000 * 60 * 5); // 5分钟
      })
    },
    startSync() {
      return new Promise((resolve, reject) => {
        this.api.syncLogistics().then(res => {
          this.isSyncLogistics = true;
          var interval = setInterval(() => {
            this.api.syncLogisticsStatus().then(res => {
              if (res.syncStatus != 1) {
                clearInterval(interval);
                this.isSyncLogistics = false;
                this.getMessage();
                resolve(res);
              }
            }).catch(err => {
              clearInterval(interval);
              this.isSyncLogistics = false;
              resolve(res);
            })
          }, 3000);
        }).catch(err => {
          reject(err);
        })
      })
    },
    // onSync() {
    //   this.$confirm('是否确定进行数据同步操作？', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     // console.log("确定")
    //     this.syncOrder();
    //   }).catch(() => {
    //     console.log("取消");
    //   });
    // },
    // syncOrder() {
    //   this.syncLoading = this.$loading({
    //     lock: true,
    //     text: "正在同步...",
    //     spinner: "el-icon-loading",
    //     customClass: "my_loading",
    //     background: "rgba(0, 0, 0, 0.3)",
    //   });
    //   this.api.sync().then(res => {
    //     this.isSyncOrder = true;
    //     this.getSyncState();
    //   }).catch(err => {
    //     this.isSyncOrder = false;
    //     this.syncLoading.close();
    //   })
    // },
    // getSyncState() {
    //   // 0：空闲，无抓取任务
    //   // 1：正在抓取中
    //   // 2：抓取已完成，成功
    //   // 3：抓取已中止，失败
    //   var interval = setInterval(() => {
    //     this.api.syncStatus().then(res => {
    //       if (res.syncStatus != 1) {
    //         clearInterval(interval);
    //         this.isSyncOrder = false;
    //         this.syncLoading.close();
    //         if (res.syncStatus == 2) this.$message.success("抓取完成");
    //         if (res.syncStatus == 3) this.$message.error("抓取失败，已终止");
    //         //隐藏组件
    //         this.refresh = false;
    //         this.$nextTick(() => {
    //           //显示组件
    //           this.refresh = true;
    //         });
    //       }
    //     }).catch(err => {
    //       clearInterval(interval);
    //       this.isSyncOrder = false;
    //       this.syncLoading.close();
    //     })
    //   }, 5000);
    // },
    getMessage() {
      this.messageApi.getMessage().then(res => {
        if (res) {
          this.msgList = res;
        }
      })
    },
    setMsgAllRead() {
      var msg = this.msgList.filter(x => x.isRead == false);
      console.log("allread", msg);
      var ids = msg.map(x => x.id)
      if (ids.length > 0) {
        this.messageApi.read(ids).then(res => {
          this.msgList.forEach(x => x.isRead = true)
        })
      }
    },
    setMsgRead(data) {
      console.log("read", data)
      this.messageApi.read([data.id]).then(res => {
        data.isRead = true
      })
    },
    showMenu(e, data) {
      var menu_el = document.querySelector("#content-menu");
      menu_el.style.top = (e.target.offsetTop + e.offsetY) + "px";
      menu_el.style.left = (e.target.offsetLeft + e.offsetX + 1) + "px";
      this.showContentMenu = true;
      this.contentData = data;
    },
    copyOrderSn() {
      if (this.contentData) {
        navigator.clipboard.writeText(this.contentData.orderSn).then(() => {
          this.$message.success('复制成功');
        }).catch(err => {
          console.log('复制失败', err);
          this.$message.error('复制失败');
        });
      }
      this.showContentMenu = false;
      this.contentData = null;
    },
    closeMenu(e) {
      if (e.target.parentNode.id != "content-menu") {
        this.showContentMenu = false;
        this.contentData = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.app-head {
  position: fixed;
  z-index: 10;
  border-width: 0px;
  width: 100%;
  height: 64px;
  background-color: #001529;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ffffff;
  cursor: default;
  user-select: none;

  .title {
    font-weight: bold;
    width: 260px;
    text-align: center;
    line-height: 64px;
  }

  .menu {
    display: flex;
    align-items: center;
    width: calc(100% - 560px);

    .menu-item {
      width: 160px;
      text-align: center;
      line-height: 64px;
      cursor: pointer;
    }

    .active {
      background-color: #173551;
    }
  }

  .action {
    width: 300px;
    line-height: 64px;
    height: 100%;
    display: flex;
    justify-content: flex-end;

    .logo {
      width: 50px;
      display: flex;
      align-items: center;
      margin: unset;

      .el-image {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
  }
}

.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 64px);
  padding-top: 64px;
  // padding: 20px;
  width: 100%;
  position: relative;
  // overflow: hidden;
}

.text-hidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.content-menu {
  min-width: 120px;
  position: fixed;
  margin-bottom: 0 !important;
  background-color: #ffffff;
  box-shadow: 0 0 6px 0px #C0C4CC;
  border-radius: 8px;

  .item {
    line-height: 32px;
    padding: 0 10px;
    cursor: pointer;
  }

  .item:hover {
    color: #409EFF;
  }
}

.msg-icon {
  height: 100%;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  i {
    font-size: 22px;
  }

  .el-badge {
    display: inherit;
  }
}

.msg-title {
  padding: 0 5px;
  line-height: 36px;
  margin-bottom: 0 !important;
}

.msg-box {
  margin-top: 5px;
  width: 100%;
  height: 400px;
  overflow: auto;

  .msg-item {
    height: 50px;
    padding: 5px;
    cursor: pointer;
  }

  .msg-is-click {
    color: #C0C4CC;
  }

  .msg-item:hover {
    background-color: #f1f8ff;
    color: #409EFF;
  }
}

.user-info {
  color: #ffffff;
  max-width: 140px;
  min-width: 100px;
  text-align: center;
  cursor: pointer;
  padding: 0 5px;
}

.day {
  color: #F56C6C;
  margin-right: 5px;
}

.user-info-item {
  max-width: 200px;
  line-height: 28px;
}

.user-info-box {
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;

  .btn {
    color: #409EFF;
    cursor: pointer;
  }
}
</style>